module.exports = __webpack_public_path__ + "img/p30.1273a8d9.png";